import React from 'react';
import { Col, Row } from 'antd';


const BannerTemplate = () => {
    return(
        <Row className="banner-template-container"> 
            <Row style={{margin: '4px', fontWeight: 500}}>
                Category Title
            </Row>

            <Col span={8} className="text-align-center banner-template-borders-box1 banner-template-box-a " >
                <div style={{marginTop: '64%'}}>
                    1
                </div>
            </Col>

            <Col span={8} className="text-align-center banner-template-border-column" style={{height: '100%'}} >
                <Row className="banner-template-box-b banner-template-border-bottom">
                    <div className="banner-template-item"> 2 </div>
                </Row>
                <Row className="banner-template-box-b ">   
                <div className="banner-template-item"> 3 </div>
                </Row>
            </Col>
            
            <Col span={8} className="text-align-center banner-template-border-column" style={{height: '100%'}} >
                <Row className="banner-template-box-b banner-template-border-bottom">
                    <div className="banner-template-item"> 4 </div>
                </Row>

                <Row className="banner-template-box-b ">
                    <div className="banner-template-item"> 5 </div>
                </Row>
            </Col>
            
        </Row>
    )
}

export default BannerTemplate;


// WEBPACK FOOTER //
// ./src/components/featured/modal/banner-template.js